<template>
  <div class='detail'>
    <el-steps :active="Number(data.state)-1" :space="200" finish-status="success" process-status="success" style="margin:0 auto;width:800px">
      <el-step :title="item.text" v-for="item in stateOptions" :key="item.text"></el-step>
    </el-steps>
    <el-form ref="form" size="small" :model="data" label-width="120px" style="margin-top:20px;">
      <el-form-item label="标题">
        <span class="text">{{data.complaint_title}}</span>
      </el-form-item>
      <el-form-item label="来源">
        <span class="text">{{data.source}}</span>
      </el-form-item>
      <el-form-item label="投诉人">
        <el-tag>{{data.complainant_name}}</el-tag>
      </el-form-item>
      <el-form-item label="被投诉人" v-if="data.respondent_name">
        <el-tag>{{data.respondent_name}}</el-tag>
      </el-form-item>
      <el-form-item label="接收人" v-if="data.receiver_name">
        <el-tag>{{data.receiver_name}}</el-tag>
      </el-form-item>
      <el-form-item label="转交人" v-if="data.assigneeVos.length>0">
        <el-tag :type="item.is_reply=='1'?'success':'info'" v-for="item in data.assigneeVos" :key="item.assignee_id" style="margin-right:10px">{{item.assignee_name}} {{item.is_reply=='0'?'(未回复)':''}} {{item.is_timeOver=='1'?'(已超时)':''}}</el-tag>
      </el-form-item>
      <el-form-item label="类型" v-if="data.complaint_type_name">
        <span class="text">{{data.complaint_type_name}}</span>
      </el-form-item>
      <el-form-item label="投诉内容">
        <span class="text">{{data.complaint_contents}}</span>
      </el-form-item>
      <el-form-item label="转交留言" v-if="data.leavingMessage">
        <span class="text">{{data.leavingMessage}}</span>
      </el-form-item>
      <el-form-item label="投诉时间">
        <span class="text">{{data.create_time|time}}</span>
      </el-form-item>
      <el-form-item label="截止时间" v-if="data.complaint_deadline">
        <span class="text">{{data.complaint_deadline|time}}</span>
      </el-form-item>
      <el-form-item label="是否满意" v-if="data.is_solve">
        <span class="text" v-if="data.is_solve=='1'">是</span>
        <span class="text" v-else-if="data.is_solve=='0'">否</span>
      </el-form-item>
      <el-form-item class="reply-list">
        <div class="reply-item" v-for="item in data.replys" :key="item.reply_id" v-if="item.reply_contents">
          <div class="title">
            <span>
              <i class="el-icon-s-comment"></i>
              {{item.respondent_name}}
            </span>
            <span class="time">
              {{item.update_time|time}}
            </span>
          </div>
          <div class="content">
            {{item.reply_contents}}
          </div>
          <el-divider></el-divider>
        </div>
      </el-form-item>
      <template v-if="$route.query.public!='1'">
        <el-form-item label="操作" v-if="(data.state!='4' && data.state!='5' && isshow)||data.is_reply=='1'||flag.canSolve">
          <el-radio-group v-model="type">
            <el-radio label="1" v-if="data.state!='4' && data.state!='5' && isshow">转交</el-radio>
            <el-radio label="2" v-if="data.is_reply=='1'">回复</el-radio>
            <!-- <el-radio label="3" v-if="data.state=='3'">关闭</el-radio> -->
            <template v-if="flag.canSolve">
              <el-radio label="4">满意</el-radio>
              <el-radio label="5">不满意</el-radio>
            </template>
          </el-radio-group>
        </el-form-item>
        <template v-if="type=='1'">
          <el-form-item label="转交人">
            <el-tag type="success" closable @close="handler.splice(index,1)" v-for="(item,index) in handler" :key="item.emplId" style="margin-right:10px">{{item.name}}</el-tag>
            <el-button plain type="primary" icon="el-icon-plus" size="small" @click="addHandler">选择转交人</el-button>
          </el-form-item>
          <el-form-item label="回复截止时间">
            <el-date-picker v-model="deadlineReplies" :picker-options="pickerOptions" type="datetime" size="small" placeholder="请选择回复截止时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="转交留言">
            <el-input type="textarea" placeholder="请输入转交留言" v-model="leavingMessage"/>
          </el-form-item>
        </template>
        <el-form-item label="回复" v-if="type=='2'">
          <el-input type="textarea" placeholder="请输入回复内容" v-model="reply"/>
        </el-form-item>
        <el-form-item v-if="type">
          <el-button type="primary" @click="submit">确定</el-button>
          <el-button @click="$router.go(-1)">取消</el-button>
        </el-form-item>
      </template>
    </el-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      pickerOptions:{
        disabledDate: time=>{
          return time.getTime() < Date.now()
        }
      },
      data: {
        assigneeVos:[]
      },
      flag:{
        canHandover:false,
        canReply:false,
        canSolve:false,
      },
      isshow:false,
      type: '',
      handler: [],  //转交人
      reply: '',  //回复
      deadlineReplies: new Date(Date.now()+86400000),  //回复截止时间
      leavingMessage:'', //转交留言
      stateOptions:{
      "1":{
        text:'待转交',
      },
      "2": {
        text: '待回复',
      },
      "3": {
        text: '已回复',
      },
      "4": {
        text: '公布',
      },
      // "5": {
      //   text: '待公布',
      //   type: 'info'
      // },
    },
    }
  },
  components: {},
  computed: {
    ...mapState({
      "userInfo": state => state.user.userInfo,
    })
  },
  watch: {},
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init(){
      this.$axios.get('/complaint/'+this.$route.query.id).then(res=>{
        this.data=res.data;

        // //判断能否转交
        // this.flag.canHandover=this.data.state=='1'&&this.userInfo.dd_user_id==this.data.receiver_id;
        // //判断能否回复
        // this.flag.canReply=(this.data.state=='1'&&this.userInfo.dd_user_id==this.data.receiver_id)||(this.data.state=='2'&&this.data.assigneeVos.length>0&&this.data.assigneeVos.map(item=>item.assignee_id).includes(this.userInfo.dd_user_id))||(this.data.state=='3'&&this.userInfo.dd_user_id==this.data.receiver_id);
        //判断能否点击已解决未解决
        this.flag.canSolve=this.userInfo.dd_user_id==this.data.complainant_id&&!this.data.is_solve&&(this.data.state=='4'||this.data.state=='5')
        //当只有回复的按钮的时候默认选中
        if(this.data.is_handle=='0'&&this.data.is_reply=='1'){
          this.type='2'
        }
      })
      this.$axios.post('/complaint/isHandOver/'+this.$route.query.id).then(res=>{
        console.log('res',res,res.data)
        if(res.data === true){
          this.isshow = true
        }else{
          this.isshow = false
        }
      })
    },
    submit(){
      if(this.type=='1'){ //转交
        if(this.handler.length>0&&this.deadlineReplies){
          this.$axios.put('/complaint/handOver/'+this.$route.query.id,{
            assignee_ids:this.handler.map(item=>item.emplId),
            deadlineReplies:this.deadlineReplies.getTime(),
            leavingMessage:this.leavingMessage
          }).then(res=>{
            this.$message.success('转交成功！');
            this.$router.push({
              name:'我的'
            })
          })
        }else{
          this.$message.error('请选择转交人和回复截止时间！')
        }
      }else if(this.type=='2'){  //回复
        if(this.reply){
          this.$axios.post('/reply',{
            complaint_id:this.$route.query.id,
            reply_contents:this.reply
          }).then(res=>{
            this.$message.success('回复成功！');
            this.$router.push({
              name:'我的'
            })
          })
        }else{
          this.$message.error('请输入回复内容！')
        }
      }else if(this.type=='3'){  //关闭
        // this.$axios.put('/complaint/closeById/'+this.$route.query.id).then(res=>{
        //   this.$message.success('关闭成功！');
        //   this.reply='';
        //   this.type='';
        //   this.init();
        // })
      }else if(this.type=='4'){  //已解决
        this.$axios.put('/complaint/solveById/'+this.$route.query.id,{
          is_solve:'1'
        }).then(res=>{
          this.$message.success('设置为已解决成功！');
          this.$router.push({
            name:'我的'
          })
        })
      }else if(this.type=='5'){  //未解决
        this.$axios.put('/complaint/solveById/'+this.$route.query.id,{
          is_solve:'0'
        }).then(res=>{
          this.$message.success('设置为未解决成功！');
          this.$router.push({
            name:'我的'
          })
        })
      }else{
        this.$message.error('请先选择操作！')
      }
    },
    addHandler(){
      this.$dd.ready(()=> {
        this.$dd.biz.contact.complexPicker({
          title:"选择转交人",            //标题
          corpId:this.$store.state.user.corpId,              //企业的corpId
          multiple:true,            //是否多选
          limitTips:"超出了",          //超过限定人数返回提示
          maxUsers:5,            //最大可选人数
          pickedUsers:this.handler.map(item=>item.emplId),            //已选用户
          pickedDepartments:[],          //已选部门
          disabledUsers:[],            //不可选用户
          disabledDepartments:[],        //不可选部门
          requiredUsers:[],            //必选用户（不可取消选中状态）
          requiredDepartments:[],        //必选部门（不可取消选中状态）
          appId:22488,              //微应用的Id
          permissionType:"GLOBAL",          //可添加权限校验，选人权限，目前只有GLOBAL这个参数
          responseUserOnly:true,        //返回人，或者返回人和部门
          startWithDepartmentId:0 ,   //仅支持0和-1
          onSuccess: res=> {
            this.handler=res.users
              /**
              {
                  selectedCount:1,                              //选择人数
                  users:[{"name":"","avatar":"","emplId":""}]，//返回选人的列表，列表中的对象包含name（用户名），avatar（用户头像），emplId（用户工号）三个字段
                  departments:[{"id":,"name":"","number":}]//返回已选部门列表，列表中每个对象包含id（部门id）、name（部门名称）、number（部门人数）
              }
              */
          },
          onFail : err=> {

          }
        });
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.detail{
  line-height: 1.5;
  padding: 0 20px;
  .text{
    color: #666;
    word-break: break-all;
  }
  .reply-list{
    .reply-item{
      .title{
        display: flex;
        justify-content: space-between;
        color: #666;
        font-weight: bold;
        .time{
          color: #999;
        }
        span{
          font-size: 14px;
          i{
            font-size: 20px;
            margin-right: 10px;
          }
        }
      };
      .content{
        margin-top: 10px;
        font-size: 14px;
        line-height: 1.5;
        color: #666;
      }
    }
  }
}
</style>